import { connect } from 'react-redux';
import { Dispatch, AnyAction } from 'redux';
import RootState from '../../modules/rootState';
import Provider, { StateFromProps, DispatchFromProps, OwnProps } from './Provider';
import ProviderInfo, { ProviderInformationRequest } from 'src/models/provider';
import * as masterData from 'src/modules/entities/masterData';
import * as providerData from 'src/modules/entities/provider';
import * as workflowData from 'src/modules/entities/workflow';
import Workflow from 'src/models/workflow';

const mapStateToProps = (rootState: RootState, props: OwnProps): StateFromProps => ({
    loadingSpecialties: masterData.selectors.getLoading(rootState),

    emailIsValid: providerData.selectors.emailIsValid(rootState),
    saving: providerData.selectors.saving(rootState),
    saved: providerData.selectors.saved(rootState),

    workflow: workflowData.selectors.getWorkflow(rootState),
    checkRetry: workflowData.selectors.checkRetry(rootState),
    statusCode: providerData.selectors.getStatusCode(rootState),
    errorMessage: providerData.selectors.getErrorMessage(rootState),
    facilities: providerData.selectors.getFacilities(rootState),
    loadingFacilities: providerData.selectors.getLoadingFacilities(rootState)
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): DispatchFromProps => ({
    addProvider: (provider: ProviderInfo): void => {
        dispatch(providerData.actions.addProviderAsync(provider));
    },
    updateEmailIsValidStatus: (): void => {
        dispatch(providerData.actions.emailIsValid(true));
    },
    updateWorkflow: (workflow: Workflow): void => {
        dispatch(workflowData.actions.storeWorkflowData(workflow));
    },
    getFacilitiesByTenantNameAsync: (tenantName: string): void => {
        dispatch(providerData.actions.getFacilitiesByTenantNameAsync(tenantName));
    },
    addProviderInformation: (providerInformation: ProviderInformationRequest) : void => {
        dispatch(providerData.actions.addProviderInformationAsync(providerInformation));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Provider);


// WEBPACK FOOTER //
// ./src/components/Provider/Provider.container.ts